import { useState, useEffect } from 'react';
import React from 'react';
import styled from 'styled-components';
import Image from 'react-bootstrap/Image';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Stack from 'react-bootstrap/Stack';
import { Spinner } from 'react-bootstrap';
import { PlanGetService } from '../../domain';
import { useNavigate } from 'react-router-dom';

import Swal from 'sweetalert2';

const StyledContainer = styled(Container)`
    padding: 0 14% !important;
    margin-top: -100px;

    @media (min-width: 300px) and (max-width: 767px) {
        padding: 0 6% !important;
        margin-top: 20px;
    }
`;

const Title = styled.h1`
    color: rgba(41, 37, 97, 1);
    font-family: Montserrat, sans-serif;
    font-size: 38px;
    font-weight: 700;
    position: relative;

    @media (min-width: 300px) and (max-width: 767px) {
        text-align: center;
    }
`;

const StyledCard = styled(Card)`
    &&& {
        height: 100%;
        border-radius: 50px;
        // box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
        background: rgb(234, 222, 208, 1);
        border: none;
        // width: 300px;
    }
`;

const StyledButton = styled.button`
    border-radius: 32px;
    background: #B01116;
    transition: all 0.2s ease-in 0s;
    padding: 5px 20px;
    max-width: fit-content;
    margin: 0 auto;
    border: none;
    font-weight: 500;
    color: #FFFFFF;
    font-family: Montserrat, sans-serif;

      &:hover {
        background-color: gray;
    }

    @media (min-width: 300px) and (max-width: 767px) {
    }
`;

const StyledCol = styled(Col)`
    &&& {
        display: flex;
        justify-content: center;
    }

    @media (min-width: 768px) and (max-width: 1024px) {
        margin-bottom: 10px;
    }

    @media (max-width: 767px) {
        margin-bottom: 10px;
    }
`;

const StyledAnchor = styled.a`
    text-decoration: none;

    &:hover {
        text-decoration: none;
    }
`;

const StyledPrice = styled.h1`
    color: rgba(41, 37, 97, 1);
    font-family: Montserrat, sans-serif;
    font-size: 36px;
    font-weight: 400;
    text-align: center;
    margin-top: 44px;
`;

const StyledPrice2 = styled.h1`
    color: rgba(41, 37, 97, 1);
    font-family: Montserrat, sans-serif;
    font-size: 49px;
    font-weight: 600;
    text-align: center;
`;

const StyledDescription = styled.h1`
    color: rgba(41, 37, 97, 1);
    font-family: Montserrat, sans-serif;
    font-size: 26px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 26px;
`;

const Loading = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);
    z-index: 2000;
`;

const CenteredText = styled.h2`
    color: rgba(41, 37, 97, 1);
    font-family: Montserrat, sans-serif;
    font-size: 30px;
    font-weight: 700;
    text-align: left;
    margin: 40px 0;

    @media (min-width: 300px) and (max-width: 767px) {
        font-size: 26px;
        margin: 20px 0;
    }
`;

const ImageStyle = {
    maxHeight: '70px',
    maxWidth: '50px',
    marginBottom: '14px', 
    filter: 'invert(13%) sepia(42%) saturate(4027%) hue-rotate(209deg) brightness(84%) contrast(114%)'
};

export default function Benefits() {
    const [loading, setLoading] = useState(false);
    const [plans, setPlans] = useState([]);
    const navigate = useNavigate();

    const _PlanGetService = new PlanGetService();

    const handleClick = () => {
        navigate('/faq'); // Navigate to the homepage or any other path you need
      };

    const handlePlan = async () => {
        try {
            setLoading(true);
            const response = await _PlanGetService.execute();
            const plan = response.plan[0];
            setPlans(plan);

            setLoading(false);
        } catch (error) {
            Swal.fire({
                text: 'Something went wrong. Please try again later.',
                icon: 'error',
                iconColor: 'black',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
                customClass: {
                    popup: 'my-popup',
                    confirmButton: 'my-confirm-button',
                    cancelButton: 'my-cancel-button'
                }
            });
            console.error('Error:', error);
            setLoading(false);
        }
    };

    useEffect(() => {
        handlePlan()
    }, []);

    return (
        <>
        {loading && (
                <Loading>
                    <Spinner animation="border" variant="light" />
                </Loading>
            )}
            <StyledContainer fluid className="p-0">
            <Row fluid >
                <Col lg={12} className="justify-content-center">
                    <Container fluid className='mt-4'>
                        <Row fluid className="mb-0.5">
                            <Col>
                                <Title>Enjoy these benefits...</Title>
                            </Col>
                        </Row>
                        <Row fluid className="justify-content-center mb-5">
                            <StyledCol sm={12} md={12} lg={4}>
                                <StyledCard className="text-center">
                                    <Card.Body style={{ paddingLeft: '0.5rem', paddingRight: '0.5rem' }}>
                                        <Stack gap={2}>
                                            <Image
                                                src={require('../../assets/fire.png')}
                                                style={{ maxHeight: '70px', maxWidth: '50px', margin: '14px' }}
                                                className="mx-auto"
                                            />
                                            <StyledAnchor
                                                // href="https://bpims.com/bpi-debit-insurance/#e-commerce-purchase-protection"
                                                target="bpims"
                                                className="mb-1"
                                            >
                                                <Stack>
                                                    <p
                                                        className="m-0"
                                                        style={{
                                                            color: '#B01116',
                                                            fontSize: '22px',
                                                            fontFamily: 'Montserrat, sans-serif ',
                                                            fontWeight: 700
                                                        }}
                                                    >
                                                        Fire and Lightning
                                                    </p>
                                                    <p
                                                        className="m-0"
                                                        style={{
                                                            color: '#B01116',
                                                            fontSize: '22px',
                                                            fontFamily: 'Montserrat, sans-serif ',
                                                            fontWeight: 700
                                                        }}
                                                    >
                                                        Insurance
                                                    </p>
                                                </Stack>
                                            </StyledAnchor>
                                            <p
                                                style={{
                                                    fontFamily: 'Montserrat, sans-serif ',
                                                    fontSize: '18px',
                                                    color: '#1B1464',
                                                    margin: '0 10%' 
                                                }}
                                            >
                                                Reimbursement para sa mga gamit na nasunog o nasira dahil sa kidlat.
                                            </p>
                                        </Stack>
                                    </Card.Body>
                                </StyledCard>
                            </StyledCol>

                            <StyledCol sm={12} md={12} lg={4}>
                                <StyledCard className="text-center">
                                    <Card.Body style={{ paddingLeft: '0.5rem', paddingRight: '0.5rem' }}>
                                        <Stack gap={2}>
                                            <Image
                                                src={require('../../assets/home.png')}
                                                style={{ maxHeight: '70px', maxWidth: '64px', margin: '14px' }}
                                                className="mx-auto"
                                            />
                                            <StyledAnchor
                                                // href="https://bpims.com/bpi-debit-insurance/#identity-theft"
                                                target="bpims"
                                                className="mb-1"
                                            >
                                                <Stack>
                                                    <p
                                                        className="m-0"
                                                        style={{
                                                            color: '#B01116',
                                                            fontSize: '22px',
                                                            fontFamily: 'Montserrat, sans-serif ',
                                                            fontWeight: 700
                                                        }}
                                                    >
                                                        Earthquake, Typhoon,
                                                    </p>
                                                    <p
                                                        className="m-0"
                                                        style={{
                                                            color: '#B01116',
                                                            fontSize: '22px',
                                                            fontFamily: 'Montserrat, sans-serif ',
                                                            fontWeight: 700
                                                        }}
                                                    >
                                                        and Flood Insurance
                                                    </p>
                                                </Stack>
                                            </StyledAnchor>
                                            <p
                                                style={{
                                                    fontFamily: 'Montserrat, sans-serif ',
                                                    fontSize: '18px',
                                                    color: '#1B1464',
                                                    margin: '0 10%' 
                                                }}
                                            >
                                               Reimbursement para sa mga gamit na nasira ng mga kalamidad.
                                            </p>
                                        </Stack>
                                    </Card.Body>
                                </StyledCard>
                            </StyledCol>

                            <StyledCol sm={12} md={12} lg={4}>
                                <StyledCard className="text-center justify-content-center">
                                    <Card.Body style={{ paddingLeft: '0.5rem', paddingRight: '0.5rem' }}>
                                        <Stack gap={2}>
                                            <Image
                                                src={require('../../assets/robber.png')}
                                                style={{ maxHeight: '70px', maxWidth: '52px', margin: '14px' }}
                                                className="mx-auto"
                                            />
                                            <StyledAnchor
                                                // href="https://bpims.com/bpi-debit-insurance/#electronic-funds-transfer-fraud"
                                                target="bpims"
                                                className="mb-1"
                                            >
                                                <Stack>
                                                    <p
                                                        className="m-0"
                                                        style={{
                                                            color: '#B01116',
                                                            fontSize: '22px',
                                                            fontFamily: 'Montserrat, sans-serif ',
                                                            fontWeight: 700
                                                        }}
                                                    >
                                                       Insurance from 
                                                    </p>
                                                    <p
                                                        className="m-0"
                                                        style={{
                                                            color: '#B01116',
                                                            fontSize: '22px',
                                                            fontWeight: 700
                                                        }}
                                                    >
                                                       Robbery and Burglary
                                                    </p>
                                                </Stack>
                                            </StyledAnchor>
                                            <p
                                                style={{
                                                    fontFamily: 'Montserrat, sans-serif ',
                                                    fontSize: '18px',
                                                    color: '#1B1464',
                                                    margin: '0 10%' 
                                                }}
                                            >
                                                Reimbursement para sa mga nanakaw na gamit sa loob ng inyong bahay.
                                            </p>
                                        </Stack>
                                    </Card.Body>
                                </StyledCard>
                            </StyledCol>
                        </Row>
                        <Row fluid className="justify-content-center">
                            <Col lg={12}>
                                <CenteredText>…and even more protection.</CenteredText>
                            </Col>
                        </Row>
                        <Row fluid className="justify-content-center mb-5">
                            <StyledCol sm={12} md={12} lg={4}>
                                <StyledCard className="text-center">
                                    <Card.Body style={{ paddingLeft: '0.5rem', paddingRight: '0.5rem' }}>
                                        <Stack gap={2}>
                                            <Image
                                                src={require('../../assets/security.png')}
                                                style={ImageStyle}
                                                className="mx-auto"
                                            />
                                            <StyledAnchor target="bpims" className="mb-1">
                                                <Stack>
                                                <p
                                                        className="m-0"
                                                        style={{
                                                            color: '#B01116',
                                                            fontSize: '22px',
                                                            fontFamily: 'Montserrat, sans-serif ',
                                                            fontWeight: 700
                                                        }}
                                                    >
                                                        Home Structure
                                                    </p>
                                                    <p
                                                        className="m-0"
                                                        style={{
                                                            color: '#B01116',
                                                            fontSize: '22px',
                                                            fontFamily: 'Montserrat, sans-serif ',
                                                            fontWeight: 700
                                                        }}
                                                    >
                                                        Coverage
                                                    </p>
                                                </Stack>
                                            </StyledAnchor>
                                            <p
                                                style={{
                                                    fontFamily: 'Montserrat, sans-serif ',
                                                    fontSize: '18px',
                                                    color: '#1B1464',
                                                    margin: '0 10%' 
                                                }}
                                            >
                                                Bukod sa mga kagamitan sa loob ng bahay, covered na rin ang mismong bahay at leasehold improvements ninyo!
                                            </p>
                                        </Stack>
                                    </Card.Body>
                                </StyledCard>
                            </StyledCol>
                            <StyledCol sm={12} md={12} lg={4}>
                                <StyledCard className="text-center">
                                    <Card.Body style={{ paddingLeft: '0.5rem', paddingRight: '0.5rem' }}>
                                        <Stack gap={2}>
                                            <Image
                                                src={require('../../assets/protect.png')}
                                                style={ImageStyle}
                                                className="mx-auto"
                                            />
                                            <StyledAnchor target="bpims" className="mb-1">
                                                <Stack>
                                                <p
                                                        className="m-0"
                                                        style={{
                                                            color: '#B01116',
                                                            fontSize: '22px',
                                                            fontFamily: 'Montserrat, sans-serif ',
                                                            fontWeight: 700
                                                        }}
                                                    >
                                                        Comprehensive Personal 
                                                    </p>
                                                    <p
                                                        className="m-0"
                                                        style={{
                                                            color: '#B01116',
                                                            fontSize: '22px',
                                                            fontFamily: 'Montserrat, sans-serif ',
                                                            fontWeight: 700
                                                        }}
                                                    >
                                                        Liability Insurance
                                                    </p>
                                                </Stack>
                                            </StyledAnchor>
                                            <p
                                                style={{
                                                    fontFamily: 'Montserrat, sans-serif ',
                                                    fontSize: '18px',
                                                    color: '#1B1464',
                                                    margin: '0 10%' 
                                                }}
                                            >
                                              Pambayad sa pinsala na tinamo ng third party para sa bodily injury and property damage habang nasa loob ng inyong tahanan.
                                            </p>
                                        </Stack>
                                    </Card.Body>
                                </StyledCard>
                            </StyledCol>
                            <StyledCol sm={12} md={12} lg={4}>
                                <StyledCard className="text-center">
                                    <Card.Body style={{ paddingLeft: '0.5rem', paddingRight: '0.5rem' }}>
                                        <Stack gap={2}>
                                            <Image
                                                src={require('../../assets/repair.png')}
                                                style={ImageStyle}
                                                className="mx-auto"
                                            />
                                            <StyledAnchor target="bpims" className="mb-1">
                                                <Stack>
                                                <p
                                                        className="m-0"
                                                        style={{
                                                            color: '#B01116',
                                                            fontSize: '22px',
                                                            fontFamily: 'Montserrat, sans-serif ',
                                                            fontWeight: 700
                                                        }}
                                                    >
                                                          Home Assistance
                                                    </p>
                                                </Stack>
                                            </StyledAnchor>
                                            <p
                                                style={{
                                                    fontFamily: 'Montserrat, sans-serif ',
                                                    fontSize: '18px',
                                                    color: '#1B1464',
                                                    margin: '0 10%' 
                                                }}
                                            >
                                               Emergency assistance para sa mga lock repairs, glass repairs, at electrical work.
                                            </p>
                                        </Stack>
                                    </Card.Body>
                                </StyledCard>
                            </StyledCol>
                        </Row>
                        <Row fluid className="justify-content-center text-center">
                            <StyledButton
                            onClick={handleClick}
                            >
                                LEARN MORE WITH OUR FAQs
                            </StyledButton>
                        </Row>
                        <Row>
                            <Col>
                                <StyledPrice>Exclusively available to you at</StyledPrice>
                                <StyledPrice2> PHP {plans.premAmt}</StyledPrice2>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <StyledDescription>mula sa <strong>PHP 1,188</strong> noong nakaraang taon</StyledDescription>
                            </Col>
                        </Row>
                    </Container>
                </Col>
            </Row>
        </StyledContainer>
        </>
        
    );
}
